<template>
  <div class="client-list main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Lista de afiliados</span>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <b-form-input type="text" placeholder="Buscar afiliado" v-model="searchBy"></b-form-input>
              </b-col>
              <b-col cols="auto">
                <router-link v-if="canAdd" tag="a" class="btn btn-primary btn-sm mr-2" :to="'/'+url+'/'+newTerm"><i class="far fa-dot-circle"></i> Cadastrar afiliado</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Lista de afiliados</p>
                  <p class="title"><small>{{ pagination.total }} afiliados cadastrados</small></p>
                </div>
              </div>
              <div class="content">


                <b-table class="table table-responsive w-100 d-block d-md-table"
                         :items="affiliates"
                         :fields="fields"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         @sort-changed="sortingChanged"
                         :no-local-sorting="true"
                         @row-clicked="rowClicked">

<!--                  <template #cell(created_at)="data">-->
<!--                    {{ moment(affiliate.created_at).format('DD/MM/YYYY') }}-->
<!--                  </template>-->
                </b-table>
<!--                <table class="table table-responsive w-100 d-block d-md-table">-->
<!--                  <thead>-->
<!--                    <tr>-->
<!--                      <th>Nome</th>-->
<!--&lt;!&ndash;                      <th>É cliente</th>&ndash;&gt;-->
<!--                      <th>URL</th>-->
<!--                      <th>Nº de clientes</th>-->
<!--                      <th>Data de cadastro</th>-->
<!--                    </tr>-->
<!--                  </thead>-->
<!--                  <tbody>-->
<!--                    <router-link tag="tr" :to="'/'+url+'/'+affiliate.id" v-for="affiliate in affiliates" :key="affiliate.id">-->
<!--                      <td>{{ affiliate.name }}</td>-->
<!--&lt;!&ndash;                      <td>{{ affiliate.client_id != null ? 'Sim' : 'Não' }}</td>&ndash;&gt;-->
<!--                      <td>{{ affiliate.slug }}</td>-->
<!--                      <td>{{ affiliate.clients_count }}</td>-->
<!--                      <td>{{ moment(affiliate.created_at).format('DD/MM/YYYY') }}</td>-->
<!--                    </router-link>-->
<!--                  </tbody>-->
<!--                </table>-->
                <p v-if="searchBy == '' && affiliates.length == 0" class="text-center sub-title">Você ainda não possui nenhum afiliado cadastrado.</p>
                <p v-if="searchBy != '' && affiliates.length == 0" class="text-center sub-title">A sua busca por afiliados não encontrou nenhum resultado.</p>

                <div v-if="pagination.lastPage > 1">
                  <hr>
                  <b-pagination v-model="pagination.currentPage" :total-rows="pagination.lastPage * pagination.perPage" :per-page="pagination.perPage" limit="15" align="fill" first-number last-number @change="getAffiliates"></b-pagination>
                </div>

              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: '',
        newTerm: '',
        module: '',

        pagination: {
          currentPage: 1,
          lastPage: 1,
          perPage: 20,
          total: 0
        },

        canSee: true,
        canAdd: true,
        canEdit: true,

        sortBy: 'clients_count',
        sortDesc: true,
        fields: [
          { key: 'name', label: 'Nome', sortable: true },
          { key: 'slug', label: 'URL', sortable: true },
          { key: 'clients_count', label: 'Nº de clientes', sortable: true },
          { key: 'created_at', label: 'Data de cadastro', sortable: true,
            formatter: (value, key, item) => {
              return this.moment(item.created_at).format('DD/MM/YYYY')
            }
          }
        ],
        affiliates: [],
        affiliatesFiltered: [],

        searchBy: ''
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.url = 'afiliados';
      this.newTerm = 'cadastrar-afiliado';
      this.module = 'affiliates';

      this.canSee = true;
      this.canAdd = true;
      this.canEdit = true;

      this.getAffiliates(this.pagination.currentPage);
    },
    watch: {
      searchBy: function() {
        this.pagination.currentPage = 1;
        this.getAffiliates(1);
      }
    },
    methods: {
      sortingChanged(ctx) {
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.getAffiliates(0);
      },
      rowClicked(item, index, event) {
        this.$router.push({ path: '/'+this.url+'/'+item.id });
      },
      getAffiliates(page) {
        let affiliatesData = {
          name: this.searchBy,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc ? 1 : 0,
          page: page,
        };
        this.api.getAffiliates(affiliatesData).then(res => {
          this.affiliates = res.data.data;

          this.pagination.currentPage = res.data.current_page;
          this.pagination.lastPage = res.data.last_page;
          this.pagination.total = res.data.total;

          this.eventBus.$emit('IS_LOADING', false);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Affiliates', res);
        }).catch(err => {
          this.$swal('Ops...', 'Não conseguimos carregar os afiliados! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Affiliates', err.response);
        });
      },
    }
  }
</script>

<style lang="scss">
  .main-content-cj {
    &.client-list {
      padding: 20px 0;

      .box-cj {
        .content {
          th {
            font-size: 14px;
            color: $cadetGray;
            border-top: 0;
          }

          tbody {
            font-size: 14px;
            color: $waikawaGray;

            .line-add {
              padding: 10px 0;
            }

            tr:nth-child(even) {
              background-color: $whisper;
            }

            tr:nth-child(odd) {
            }
          }
        }
      }
    }
  }
</style>
